import axios from 'axios'
import { API_ROOT } from './app.config'
import stores from '../stores'
import MaintenanceStore, { MAINTENANCE_HEADER } from '../stores/maintenanceStore'

class AxiosConfig {
  constructor() {
    const { authStore, maintenanceStore } = stores

    axios.defaults.baseURL = API_ROOT
    axios.interceptors.request.use(
      async (config) => {
        // Só renova quando há sessão. Sem usuário (antes do login, na volta do login) a renovação
        // abria um iframe de login silencioso que carregava o portal inteiro dentro dele, que por
        // sua vez disparava as próprias requisições e outro iframe, em cascata.
        if (authStore.user && authStore.accessTokenExpired) await authStore.refreshAccessToken()

        const token = authStore.accessToken

        config.headers.Authorization = token && `Bearer ${token}`

        config.headers.HostName = window.location.origin

        return config
      },
      (error) => Promise.reject(error)
    )

    // Token recusado (401) mesmo sem estar vencido pelo relógio do navegador (relógio do computador
    // adiantado/atrasado, token revogado): renova uma vez e repete a requisição, em vez de mostrar
    // "Usuário ou senha inválido".
    axios.interceptors.response.use(
      (response) => {
        // Equipe PlantScanner num tenant em manutenção: a API deixa passar e avisa pelo cabeçalho
        const headers = (response && response.headers) || {}
        maintenanceStore.markBypass(headers[MAINTENANCE_HEADER] === 'active')
        return response
      },
      async (error) => {
        const original = error && error.config
        const status = error && error.response && error.response.status
        // Tenant em manutenção (PlantScanner Admin): troca o portal pela tela de manutenção
        if (MaintenanceStore.isMaintenanceError(error)) {
          maintenanceStore.enter(error.response.data)
          return Promise.reject(error)
        }
        if (status === 401 && original && !original.__retriedAfter401 && authStore.isLoggedIn) {
          original.__retriedAfter401 = true
          await authStore.refreshAccessToken()
          if (authStore.accessToken) return axios(original)
        }
        return Promise.reject(error)
      }
    )
  }
}

export default new AxiosConfig()
